export const RoutesName = {
  KONTO: ":konto",
  ORG_FORM_MED_MOMS: ":orgForm/:medMoms",
  ORG_FORM_MED_MOMS_KONTO: ":orgForm/:medMoms/:kontonummer",
  NO_MATCH: "*",
}
